import colors from '../../colors';

const common = {
  borderColor: colors.primary.grey1,
};

export default common;
